var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playwright-test"},[_c('h1',[_vm._v("Playwright Test Page")]),_c('button',{attrs:{"id":"api-button"},on:{"click":_vm.callApi}},[_vm._v("Call API")]),(_vm.loading)?_c('div',{attrs:{"id":"loading"}},[_vm._v("Loading...")]):_vm._e(),_c('div',{attrs:{"id":"api-result"}},[_vm._v(_vm._s(_vm.result))])])
}
var staticRenderFns = []

export { render, staticRenderFns }